import { useState } from 'react';

export function useFormValidation() {
  const [alarmName, setAlarmName] = useState(false);
  const [alarmEmail, setAlarmEmail] = useState(false);
  const [alarmCpf, setAlarmCpf] = useState(false);
  const [alarmBirthdate, setAlarmBirthdate] = useState(false);
  const [alarmTelephone, setAlarmTelephone] = useState(false);
  const [alarmCep, setAlarmCep] = useState(false);
  const [alarmAddress, setAlarmAddress] = useState(false);
  const [alarmDistrict, setAlarmDistrict] = useState(false);
  const [alarmCity, setAlarmCity] = useState(false);
  const [alarmState, setAlarmState] = useState(false);
  const [alarmNumber, setAlarmNumber] = useState(false);

  return {
    alarmName, setAlarmName,
    alarmEmail, setAlarmEmail,
    alarmCpf, setAlarmCpf,
    alarmBirthdate, setAlarmBirthdate,
    alarmTelephone, setAlarmTelephone,
    alarmCep, setAlarmCep,
    alarmAddress, setAlarmAddress,
    alarmDistrict, setAlarmDistrict,
    alarmCity, setAlarmCity,
    alarmState, setAlarmState,
    alarmNumber, setAlarmNumber
  };
}
